import FieldAutocompleteCountry from './FieldAutocompleteCountry';

const FieldAutocompleteCountryPhoneCode=(props)=>{
  return <FieldAutocompleteCountry {...props} showPhoneCode={true}/>;
};

export default FieldAutocompleteCountryPhoneCode;